import React from 'react';
import { Workstation } from 'app/containers/OrderDetails/types';
import { PackageOrder } from 'app/models/PackageOrder';
import { LabelPage } from 'app/containers/OrderDetails/PackagesTab/LabelsToPrint/LabelPage';
import PickingPage from 'app/containers/OrderDetails/HeaderOrderDetails/PrintOrder/PickingPage';
import { useSelector } from 'react-redux';
import { selectedTrolley } from 'app/containers/OrderDetails/HeaderOrderDetails/PrintOrder/selectors';
import { Trolley } from 'app/models/Trolley';
import PickingCornerPage from 'app/containers/OrderDetails/HeaderOrderDetails/PrintOrder/PickingPage/PickingCornerPage';
import { PartOrder } from 'app/models/PartOrder';
import { PickingOrderStrategy } from 'shared/printing/pickingOrder';

interface Props {
  order: PartOrder;
  workstation: Workstation;
  showPicking?: boolean;
  showLabels?: boolean;
  pickingOrderStrategy: PickingOrderStrategy;
}

const PrintContent = ({
  order,
  workstation,
  showPicking = true,
  showLabels = true,
  pickingOrderStrategy,
}: Props) => {
  const trolleys = useSelector(selectedTrolley(workstation));

  if (!showPicking && !showLabels) return null;

  const renderTrolley = (trolley: Trolley) => (
    <div key={trolley.id}>
      {showPicking && trolley.production.length > 0 && (
        <PickingPage
          order={order}
          pieces={trolley.production}
          workstation={workstation}
          trolleyName={trolley.name}
          drawerId={trolley.drawer}
          pickingOrderStrategy={pickingOrderStrategy}
        />
      )}
      {showLabels && order.carrier?.name !== 'BPOST' &&
        trolley.packages.map((pkg: PackageOrder) => (
          <LabelPage partOrder={order} packageOrder={pkg} key={pkg.id} />
        ))}
    </div>
  );

  if (!trolleys || trolleys.length === 0) return null;

  const shouldRenderCornerLabel =
    showLabels &&
    order.carrier?.name !== 'BPOST' &&
    order.carrier?.name !== 'B-POST' &&
    !order.direct;

  if (workstation === Workstation.Corner) {
    return (
      <div>
        {showPicking && (
          <PickingCornerPage
            order={order}
            trolleys={trolleys}
            workstation={workstation}
          />
        )}
        {shouldRenderCornerLabel &&
          trolleys.map(trolley =>
            trolley.packages.map((pkg: PackageOrder) => (
              <LabelPage partOrder={order} packageOrder={pkg} key={pkg.id} />
            )),
          )}
      </div>
    );
  } else {
    return <div>{trolleys.map(trolley => renderTrolley(trolley))}</div>;
  }
};

export default PrintContent;
